import * as React from 'react';
import { cn } from '@/shared/lib/utils';

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
    function Input({ className, ...props }, ref) {
        return (
            <input
                ref={ref}
                className={cn(
                    'flex h-11 w-full rounded-2xl border border-border bg-panel px-4 text-sm text-foreground outline-none placeholder:text-muted focus-visible:border-1 focus-visible:border-[#4096F3]',
                    className,
                )}
                {...props}
            />
        );
    },
);